import { all } from "redux-saga/effects";

import { accountSagas } from "./accounts/root";
import { authenticationSagas } from "./authentication/root";
import { classAnalyticsSagas } from "./class-analytics/root";
import { classManagementSagas } from "./class-management/root";
import { classesSagas } from "./classes/root";
import { courseAuthorSagas } from "./course-author/root";
import { coursesSagas } from "./courses/root";
import { dashboardSagas } from "./dashboard/root";
import { exportedScormPackagesSagas } from "./exported-scorm-packages/root";
import { miscellaneousSagas } from "./miscellaneous/root";
import { scormPackageAnalyticsSagas } from "./scorm-package-analytics/root";
import { scormPackageManagementSagas } from "./scorm-package-management/root";
import { selectOrganizationSagas } from "./select-organization/root";
import { settingsSagas } from "./settings/root";
import { themeListSagas } from "./theme-list/root";
import { themeManagementSagas } from "./theme-management/root";

export function* applicationSagas() {
  yield all([
    authenticationSagas(),
    accountSagas(),
    selectOrganizationSagas(),
    classAnalyticsSagas(),
    scormPackageAnalyticsSagas(),
    miscellaneousSagas(),
    classesSagas(),
    coursesSagas(),
    dashboardSagas(),
    classManagementSagas(),
    scormPackageManagementSagas(),
    settingsSagas(),
    themeManagementSagas(),
    themeListSagas(),
    exportedScormPackagesSagas(),
    courseAuthorSagas(),
  ]);
}
